import config from '../../config'

export const parseTitle = (title) => {
	return (title && title !== '') ? (title + ' | ' + config.head.titlePostFix) : config.head.titlePostFix;
	// return (title && title !== '' && title !== config.head.titlePostFix) ? (title + ' | ' + config.head.titlePostFix) : config.head.titlePostFix;
}

export default parseTitle;